<template>
  <v-col>
    <!-- sales data table -->
    <bill-table
      :key="index"
      no-search
      url-api="/bill"
      :headers="headers"
    >
      <!-- New new bill -->
      <template v-slot:urlCreate="{ item }">
        <v-btn
          class="success"
          @click.prevent="
            $router.push({
              name: 'BillForm',
            })
          "
        >
          <v-icon>mdi-plus</v-icon>
          New Bill
        </v-btn>
      </template>
      <!-- end -->

      <!-- Charges -->
      <template v-slot:charges="{ item }">
        {{ item.charges | currency }}
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <!-- bill edit -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'BillForm',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Bill info Edit</span>
        </v-tooltip>
        <!-- end -->

        <!-- Slip Print -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'BillPrint',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-printer
              </v-icon>
            </v-btn>
          </template>
          <span>Print Bill</span>
        </v-tooltip>
        <!-- end -->

        <!-- Product remove -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              @click="warningBillRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </bill-table>

    <!-- end data table -->

    <!-- Bill remove warning -->
    <v-dialog
      v-model="billRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="billRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeBill"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import BillDataTable from "../common/DataTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    "bill-table": BillDataTable,
  },
  data() {
    return {
      bill: [],
      billRemoveWarning: false,
      index: 1,

      headers: [
        {
          text: "Created At",
          align: "start",
          sortable: true,
          value: "created_at",
        },

        {
          text: "Name",
          sortable: true,
          value: "name",
        },

        {
          text: "Date",
          sortable: false,
          value: "date",
        },

        {
          text: "Charges",
          sortable: true,
          value: "charges",
          slot: "charges",
        },
        {
          text: "Tax Rate",
          sortable: true,
          value: "taxRate",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    removeBill() {
      window.axios.delete("/bill/" + this.$data.bill.id).then((response) => {
        this.feedback(response.data.message);
        this.billRemoveWarning = false;
        this.$data.index++;
      });
    },

    warningBillRemove(bill) {
      this.bill = bill;
      this.billRemoveWarning = true;
    },
  },
};
</script>
